/**
 * Default data structures and validation for LinCal calendar data
 */

import { generateId, generateTimestamp } from './idUtils';
import { HOLIDAYS_PROJECT_ID, CURRENT_VERSION } from './constants';

/**
 * Get default data structure with empty arrays and default projects
 * @param {string} personalProjectName - Name for the personal project (defaults to 'Personal')
 * @returns {Object} Default calendar data
 */
export function getDefaultData(personalProjectName = 'Personal') {
  const personalProjectId = generateId('proj');
  return {
    version: CURRENT_VERSION,
    selectedProjectId: personalProjectId,
    projects: [
      {
        id: HOLIDAYS_PROJECT_ID,
        name: 'Holidays',
        color: '#ff6b6b',
        visible: true,
        isSystem: true,
        createdAt: generateTimestamp()
      },
      {
        id: personalProjectId,
        name: personalProjectName,
        color: '#4285f4',
        visible: true,
        createdAt: generateTimestamp()
      }
    ],
    events: [],
    milestones: []
  };
}

/**
 * Validate that data has the required structure
 * @param {Object} data - Data to validate
 * @returns {boolean} True if valid
 */
export function validateData(data) {
  if (!data || typeof data !== 'object') {
    return false;
  }
  
  if (!data.version || !data.projects || !data.events || !data.milestones) {
    return false;
  }
  
  if (!Array.isArray(data.projects) || !Array.isArray(data.events) || !Array.isArray(data.milestones)) {
    return false;
  }
  
  return true;
}

/**
 * Migrate data by ensuring holidays project exists
 * Modifies the data object in place
 * @param {Object} data - Data to migrate
 */
export function migrateData(data) {
  // Ensure holidays project exists (for migration from older versions)
  const hasHolidaysProject = data.projects.some(p => p.id === HOLIDAYS_PROJECT_ID);
  if (!hasHolidaysProject) {
    data.projects.unshift({
      id: HOLIDAYS_PROJECT_ID,
      name: 'Holidays',
      color: '#ff6b6b',
      visible: true,
      isSystem: true,
      createdAt: generateTimestamp()
    });
  }
}
